module.exports = __webpack_public_path__ + "img/sample-trusted.0e28400b.png";